import { IoInformationCircleOutline } from "react-icons/io5";
import classNames from "./InvalidMessage.module.css";

const InvalidMessage = (props: { message: string }) => {
  return (
    <div className={classNames.InvalidMessage}>
      <IoInformationCircleOutline />
      {props.message}
    </div>
  );
};

export default InvalidMessage;
